import { repriceTicketFromCart } from './cart-totals.helper'

/**
 * Seats whose travel insurance the customer can accept/decline on the payment
 * step: flagged when booked (leg of the RODOSOFT gateway with insurance quoted -
 * direct or connection -, not a public body sale - see bus-seat-selection
 * `validateAndSelect`)
 * @param {Array} seats The booked seats (outbound + return, every connection leg)
 * @return {Array} the eligible seats
 */
export function getInsuranceEligibleSeats(seats = []) {
	return seats.filter((seat) => seat && seat.insuranceEligible)
}

/**
 * The insurance price per passenger for the eligible seats, as shown under the
 * checkbox: a single value when every leg costs the same ("R$ 8,40"), or one
 * per leg otherwise ("Curitiba > Joinville: R$ 8,40 · Joinville > Itajaí: R$ 5,10").
 * A points-only purchase pays the insurance in points, so it shows points.
 * @param {Array} seats Eligible seats (outbound + return, every connection leg)
 * @return {string} the formatted value, empty when there is nothing to show
 */
export function formatInsuranceOffer(seats = []) {
	const format = (seat) =>
		seat.offeredInsurancePoints > 0
			? `${seat.offeredInsurancePoints.toLocaleString('pt-BR')} pts`
			: seat.offeredInsurance.$toReais()

	// Um valor por trecho: as poltronas do mesmo trecho custam o mesmo seguro.
	const legs = []
	seats.forEach((seat) => {
		const label = `${seat.originCity} > ${seat.destinationCity}`

		if (!legs.some((leg) => leg.label === label))
			legs.push({ label, value: format(seat) })
	})

	const values = [...new Set(legs.map((leg) => leg.value))]

	if (values.length <= 1) return values[0] || ''

	return legs.map((leg) => `${leg.label}: ${leg.value}`).join(' · ')
}

/**
 * Applies the insurance choice to the booked seats: eligible seats take the
 * new flag, and every seat takes the prices/points the repriced cart returned.
 * @param {object} cart The cart summary returned by `CartService.setInsurance`
 * @param {Array} seats The seats to update
 * @param {boolean} withInsurance The customer's choice
 * @return {Array} the updated seats
 */
export function applyInsuranceChoice(cart, seats = [], withInsurance) {
	const reprice = repriceTicketFromCart(cart)

	return seats.map((seat) => {
		const repriced = reprice(seat)

		return seat.insuranceEligible ? { ...repriced, withInsurance } : repriced
	})
}
